import {Environment} from './environment.interface';
import { version } from './version';

export const environment: Environment = {
  production: false,
  buildVersion: version,
  apiURL: '',
  appURL: ''
};
